import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M6.848 9a.667.667 0 0 0 0 1.334h.006a.667.667 0 0 0 0-1.334zM6.854 12.334c0-.369.299-.667.667-.667h.007a.667.667 0 1 1 0 1.333H7.52a.667.667 0 0 1-.667-.666M8.854 10.334a.667.667 0 0 0 0 1.333h.007a.667.667 0 1 0 0-1.333z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M11.172 1.088c.32.183.43.59.248.91l-.65 1.136a4.6 4.6 0 0 1 1.68 2.095l.176.438h.215a.667.667 0 1 1 0 1.333h-.137l-.899 5.285c-.077.45-.146.853-.248 1.176-.112.358-.286.69-.617.947-.336.26-.827.396-1.271.474A9 9 0 0 1 8.12 15a9 9 0 0 1-1.536-.128c-.434-.079-.918-.212-1.244-.465-.33-.256-.504-.588-.617-.946-.102-.325-.171-.73-.248-1.184L3.578 7h-.07a.667.667 0 0 1 0-1.333h.215l.175-.438a4.605 4.605 0 0 1 5.671-2.68l.693-1.213c.183-.32.59-.43.91-.248M8.174 3.666c.24 0 .48.027.712.078L7.787 5.667H5.16a3.27 3.27 0 0 1 3.015-2m1.932.631-.783 1.37h1.866a3.27 3.27 0 0 0-1.083-1.37M8.188 7H4.93l.854 5.014c.086.507.14.82.212 1.046.064.203.119.26.163.294.052.04.255.132.663.206.375.067.835.105 1.305.107s.932-.032 1.311-.098c.41-.072.622-.166.685-.215.044-.034.099-.09.163-.294.071-.226.126-.539.213-1.045L11.35 7z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })